/*
* @Author: gujianghua
* @Date:   2020-08-26 10:23:40
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-08-26 16:23:20
*/
import { service } from '@/utils/request'

export default {
	// 获取菜单
	getDataList(params) {
	    return service({
			url: '/cloud/statistic/courseShare/adnin/findByList',
			method: 'get',
			params: params
		})
	},
	// 添加
	add(data) {
	    return service({
			url: '/cloud/course/v1/courseShare/insert',
			method: 'post',
			data: data
		})
	},
	// 获取详情
	getById(path) {
	    return service({
			url: '/cloud/course/v1/courseShare/findById/' + path,
			method: 'get'
		})
	},
	// 修改
	update(data) {
	    return service({
			url: '/cloud/course/v1/courseShare/update',
			method: 'post',
			data: data
		})
	},
	// 删除
	delete(params) {
	    return service({
			url: '/cloud/course/v1/courseShare/delete',
			method: 'get',
			params: params
		})
	},
	// 上下架
	switch(params) {
	    return service({
			url: '/cloud/course/v1/courseShare/updateState',
			method: 'get',
			params: params
		})
	},
}


// WEBPACK FOOTER //
// ./src/api/contentManage/coursepost.js